import axios from "axios";

const communicationLogsApiBaseUrl =
  process.env.REACT_APP_TEMPLATES_API_URL;

/** Subdocuments pushed to MessageQueue.logs (queue, send, webhooks, etc.). */
export type MessageQueueLogEntry = {
  message?: string;
  conversationRole?: "outbound" | "user" | "model";
  text?: string;
  /** When the event was recorded; UI timeline reads this field only. */
  timestamp?: string | Date | { $date?: unknown; $numberLong?: string };
  response?: unknown;
  error?: unknown;
  [key: string]: unknown;
};

export type MessageLogItem = {
  _id: string;
  channel: string;
  status?: string;
  body?: string;
  recipients?: string[];
  templateId?: string;
  params?: Record<string, unknown>;
  logs?: MessageQueueLogEntry[];
  createdAt?: string;
  updatedAt?: string;
};

export type CommunicationLogsResponse = {
  ok: boolean;
  items: MessageLogItem[];
  nextCursor: string | null;
  limit: number;
};

export async function fetchCommunicationLogs(params: {
  limit?: number;
  cursor?: string | null;
  /** Multiple channels; sent as comma-separated `channel` query. */
  channels?: string[];
  /** Multiple statuses; sent as comma-separated `status` query. */
  statuses?: string[];
}): Promise<CommunicationLogsResponse> {
  const response = await axios.get<CommunicationLogsResponse>(
    `${communicationLogsApiBaseUrl}/logs`,
    {
      params: {
        limit: params.limit ?? 20,
        cursor: params.cursor || undefined,
        channel:
          params.channels && params.channels.length > 0
            ? params.channels.join(",")
            : undefined,
        status:
          params.statuses && params.statuses.length > 0
            ? params.statuses.join(",")
            : undefined,
      },
    }
  );
  return response.data;
}
